<template>
    <div>
        <div class="text-center" style="background-color: white;padding-left: 0">
            <div class="row">
                <div class="col text-right">
                    <button class="btn btn-default next margin" @click="goToBackward">
                        <icon name="backward"></icon>
                        ย้อนกลับ
                    </button>
                    <button class="btn btn-primary margin"
                            @click="imageProfile">
                        <icon name="print"></icon>
                        พิมพ์บัตรพนักงาน
                    </button>
                    <button class="btn btn-success margin"
                            @click="showConfirmModal">
                        <icon name="save"></icon>
                        บันทึกจบ
                    </button>
                </div>
            </div>
            <div id="card" class="cardWrapper">
                <img src="@/assets/profile_card2.jpg"
                     class="cardBackGround" alt="upload">
                <div class="profileImageWrapper" v-if="form.image.length > 0">
                    <img :src="form.image[0].path+'?x-request=xhr'"
                         class="profileImage" alt="upload" crossorigin="anonymous">
                </div>
                <div class="detailWrapper">
                    <div class="code">
                        <label style="font-weight: bold">รหัสพนักงาน : {{form.employee_no}}</label>
                    </div>
                    <div class="name">
                        <label style="font-weight: bold">เลขที่พาสปอร์ต/ประชาชน : {{form.citizen ? form.citizen.citizen_id : '-'}}</label>
                    </div>
                    <div class="name">
                        <label style="font-weight: bold">ชื่อพนักงาน : {{form.name}}</label>
                        <label style="font-weight: bold; padding-left: 30px">สังกัด :
                            <template v-if="form.nationality && form.nationality.group_employee == 1">A</template>
                            <template v-else-if="form.nationality && form.nationality.group_employee == 2">B</template>
                            <template v-else>-</template>
                        </label>

                    </div>
                    <div class="position">
                        <template v-if="form.occupation && form.occupation.department">
                            <label style="font-weight: bold">แผนก : {{form.occupation.department.department_name}}</label>
                        </template>
                        <br/>
                        <label style="font-weight: bold">วันที่เริ่มงาน : {{form.work_benefit ? form.work_benefit.work_start_date : '-' | moment('DD-MM-YYYY')}}</label>
                        <br/>
                        <label style="font-weight: bold">วันที่ออกบัตร : {{currentDate | moment('DD-MM-YYYY')}}</label>
                    </div>
                </div>
            </div>
        </div>
        <b-modal hide-header hide-footer ref="confirmEmp">
            <confirm-emp-modal @submit="saveEmployee">
            </confirm-emp-modal>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex"
import moment from 'moment';
import confirmEmpModal from "../../../Utility/ConfirmEmpModal";
import domtoimage from 'dom-to-image';

import {canViewSuperAdmin} from "../../../../util/Permissions";

export default {
        name: "employee-card",
        components : {confirmEmpModal},
        computed:{
            canViewSuperAdmin,
            ...mapState({
                form:state =>{
                    return state.Employee.employeeForm;
                },
                user:state=>{
                    return state.Auth.user;
                },
            })
        },
        data(){
          return{
              currentDate : '',
          }
        },
        created() {
            this.getCurrentDate();
        },
        methods:{
            showConfirmModal(){
                this.$refs.confirmEmp.show();
            },
            goToBackward(){
                this.$router.push({
                    name : "employee-information-tax"
                });
            },
            saveEmployee(value){
                if(value){
                    this.form.user_id = this.user.id;
                    this.$store.dispatch("Employee/saveEmployee",{
                        id : this.form.id,
                        data : this.form
                    });
                    this.$router.push({
                        name : "employee"
                    })
                }else{
                    this.$refs.confirmEmp.hide();
                }

            },
            imageProfile() {
                let node = document.getElementById('card');
                // var node = document.getElementsByTagName('html');
                let self = this;
                domtoimage.toPng(node)
                    .then(function (dataUrl) {
                        let img = new Image();
                        img.src = dataUrl;
                        let page = self.imageToPrint(img);
                        let pageLink = "about:blank";
                        let pwa = window.open(pageLink, "_new");
                        pwa.document.open();
                        pwa.document.write(page);
                        pwa.document.close();
                        document.querySelectorAll('button').forEach(function (element) {
                            element.classList.remove("hidden");
                        });
                    })
                    .catch(function (error) {
                        console.error('oops, something went wrong!', error);
                    });

            },
            imageToPrint(source) {
                return "<html><body onload='window.print()'><style>@media print {\n" +
                    "   .hidden-print,\n" +
                    "   tr.hidden-print,\n" +
                    "   th.hidden-print,\n" +
                    "   td.hidden-print{\n" +
                    "    display:none !important;\n" +
                    "  @page { margin: 0mm; }\n" +
                    "  html, body {\n" +
                    "    margin: 0mm;\n" +
                    "    width: 210mm;\n" +
                    "    height: 297mm;\n" +
                    "    text-align: center;\n" +
                    "  }\n" +
                    "  img {\n" +
                    "    margin-top: 0;\n" +
                    "    margin-left: 0;\n" +
                    "    height: 100%;\n" +
                    // "    height: 297mm;\n" +
                    "  }\n" +
                    "  }\n" +
                    "  body{\n" +
                    "  margin: 0mm !important;\n" +
                    "  }\n" +
                    "}</style>" + source.outerHTML + "</body></html>";
            },
            getCurrentDate(){
                this.currentDate = moment().format("YYYY-MM-DD");
            }
        }
    }
</script>

<style scoped>
    .margin{
        margin: 10px;
    }

    .cardWrapper{
        width: 450px;
        height: 716px;
        position: relative;
    }

    .cardBackGround{
        width: 450px;
        height: 716px;
    }

    .profileImageWrapper{
        max-width: 235px;
        max-height: 275px;
        position: absolute;
        top: 36px;  /* y */
        left: 112px;  /* x */
        line-height: 172px;
        overflow: hidden;
    }

    .profileImage{
        max-width: 100%;
        display: inline-block;
        margin: 0 auto;
        vertical-align: middle;
    }

    .detailWrapper{
        text-align: center;
        position: absolute;
        width: 100%;
        top: 343px;
        left: 0;
        padding: 10px 10px 0 10px;
    }

    .name{
        font-size: 22px;
        width: 100%;
        text-align: center;
        white-space: nowrap;
    }

    .code{
        font-size: 30px;
        width: 100%;
        text-align: center;
        white-space: nowrap;
    }

    .position{
        font-size: 22px;
        width: 100%;
        text-align: center;
        white-space: nowrap;
    }
</style>
